module.exports = __webpack_public_path__ + "static/media/reducer-state.fa06f5bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videoPlayer/reducer-state.png
// module id = 84
// module chunks = 0